// Formatuje datę w polskim formacie DD.MM.YYYY niezależnie od źródła.
// Obsługuje: Firestore Timestamp (z toDate), Firestore Timestamp serializowany
// ({seconds, nanoseconds}), Date, ISO string, millis (number).
export const formatDateExecution = (value) => {
  if (value == null || value === '') return '';

  let date = null;

  if (value instanceof Date) {
    date = value;
  } else if (typeof value === 'object' && typeof value.toDate === 'function') {
    date = value.toDate();
  } else if (typeof value === 'object' && typeof value.seconds === 'number') {
    date = new Date(value.seconds * 1000);
  } else if (typeof value === 'number') {
    date = new Date(value);
  } else if (typeof value === 'string') {
    const parsed = new Date(value);
    if (!isNaN(parsed.getTime())) date = parsed;
  }

  if (!date || isNaN(date.getTime())) {
    return typeof value === 'string' ? value : '';
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};
